"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfficesListApiSchema = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const officeItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('offices'),
    attributes: zod_1.z.object({
        name: zod_1.z.string(),
        address: address_schema_1.addressSchema,
        siteId: zod_1.z.string(),
        withAssistantRetrocessionRate: zod_1.z.number(),
        withoutAssistantRetrocessionRate: zod_1.z.number(),
        availableSlots: zod_1.z.number().optional().default(0),
        slotsToValidate: zod_1.z.number().optional().default(0),
        /** Set when the practice closed; closed offices stay listed for history. */
        deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
    }),
});
exports.getOfficesListApiSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(officeItemApiResponseSchema);
